// client/src/components/secure/training/TrainingCard.js — the training summary on the
// dashboard overview: what is due, CE standing, and (for supervisors) overdue + drafts.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useApiClient } from '../../../hooks/useApiClient';
import { Pill, fmtDate } from './shared';
import CollapsibleCard, { CardHeading } from '../../shared/CollapsibleCard';
import { trainingSummary } from '../../../utils/collapsibleCards';

const TrainingCard = () => {
    const api = useApiClient();
    const [d, setD] = useState(null);
    useEffect(() => { api.get('/api/training/summary').then(setD).catch(() => setD(null)); }, [api]);
    if (!d) return null;
    const ceAlerts = d.ce.filter((c) => !['complete', 'ok'].includes(c.level));
    return (
        <CollapsibleCard id="training" title="Training" summary={trainingSummary(d)} className="mt-3"
                         defaultOpen={d.overdue > 0} tone={d.overdue ? 'text-red-700 font-semibold' : undefined}>
        <div className="bg-white p-6 rounded-lg shadow mt-6">
            <div className="flex justify-between items-center">
                <CardHeading as="h3" className="text-lg font-semibold text-slate-800">Training</CardHeading>
                <Link to="/dashboard/training" className="text-sm text-indigo-700 underline">Open training</Link>
            </div>
            <p className="text-sm text-slate-700 mt-2">
                {d.open ? `${d.open} item(s) assigned to you` : 'Nothing assigned to you'}{d.overdue ? ` — ${d.overdue} overdue` : ''}
                {d.next_due ? `. Next: ${d.next_due.course_title}, due ${fmtDate(d.next_due.due_date)}` : ''}.
                {d.unread ? ` ${d.unread} new notice(s).` : ''}
            </p>
            {ceAlerts.map((c) => (
                <p key={c.licence_id} className="text-sm mt-1"><Pill s={c.level} /> CE — {c.state} {String(c.licence_type).replace(/_/g, ' ')}: {c.message}</p>
            ))}
            {d.supervisor && (d.supervisor.overdue > 0 || d.supervisor.drafts > 0) && (
                <p className="text-sm mt-2 text-slate-700">
                    Office: {d.supervisor.overdue} overdue training item(s){d.supervisor.drafts ? `, ${d.supervisor.drafts} draft course(s) waiting for approval` : ''}. <Link to="/dashboard/training?tab=reports" className="text-indigo-700 underline">Review</Link>
                </p>
            )}
        </div>
        </CollapsibleCard>
    );
};

export default TrainingCard;
